import { GovernanceWorkspace } from '@/components/governance/governance-workspace'

export function MemberPolls() {
  return <GovernanceWorkspace basePath="/polls" />
}
